import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="terms-container">
      <h1>Terms and Conditions</h1>

      <h2>1. Introduction</h2>
      <p>Welcome to Sairam Foods Website. These Terms and Conditions govern your use of our website and services, including ordering groceries online. By accessing or using our website, you agree to comply with these terms.</p>

      <h2>2. Eligibility</h2>
      <p>To use our services, you must be at least 18 years old or have parental/guardian consent. By placing an order, you confirm that you meet this requirement.</p>

      <h2>3. Account Login</h2>
      <p>We currently support only Google accounts for logging in to our website.</p>

      <h2>4. Orders and Payments</h2>
      <p>Orders are subject to product availability.</p>
      <ul>
        <li>We reserve the right to cancel or modify orders due to stock issues or pricing errors.</li>
        <li>   If the email ID, mobile number, or delivery address provided is invalid, we reserve the right to cancel the order without prior notice. </li>
        <li>Payments can be made either by cash or card (Pay Wave only) at the time of pickup/delivery.</li>
        <li>For card-related transactions, the following charges apply:</li>
        <ul>
          <li>Visa and Mastercard Domestic debit contactless transactions - 0.70%</li>
          <li>Visa and Mastercard Domestic credit card contactless transactions - 1.50%</li>
          <li>Visa and Mastercard International debit and credit card contactless transactions - 2.50%</li>
        </ul>
        <li>We do not store payment information; transactions are handled by secure third-party payment processors.</li>
        <li>All transactions are subject to New Zealand's Consumer Guarantees Act 1993 and Fair Trading Act 1986.</li>
      </ul>

      <h2>5. Pricing and Promotions</h2>
      <p>Prices are displayed on the website and may change without prior notice.</p>
      <ul>
        <li>Discounts and promotions are subject to terms and may be withdrawn at any time.</li>
        <li>All prices mentioned in the website are New Zealand Dollars and it includes Goods and Services Tax (GST) as required under New Zealand law.</li>
      </ul>

      <h2>6. Delivery and Pickup</h2>
      <p>Estimated delivery times are provided but are not guaranteed.</p>
      <ul>
        <li>Customers must provide accurate delivery details.</li>
        <li>If a delivery is unsuccessful due to incorrect information or unavailability, additional charges may apply.</li>
        <li>For pickup orders, the orders must be picked up from 9am to 6pm on the pickup day </li>
        <li>Delivery services comply with the Consumer Guarantees Act 1993 in terms of timeliness and quality.</li>
      </ul>

      <h2>7. Cancellation and Refund Policy</h2>
      <p>Orders can be cancelled before processing; once shipped, they cannot be cancelled.</p>
      <ul>
        <li>Refunds may be issued for defective or incorrect products, subject to verification.</li>
        <li>Perishable goods are not eligible for returns unless they are defective or expired upon delivery.</li>
        <li>We adhere to the Consumer Guarantees Act 1993, ensuring that all goods are of acceptable quality and fit for purpose.</li>
      </ul>

      <h2>8. User Responsibilities</h2>
      <p>You agree not to misuse the website or services.</p>
      <ul>
        <li>Prohibited actions include hacking, fraudulent transactions, and spreading malware.</li>
        <li>Any violation may result in account suspension and legal action.</li>
      </ul>

      <h2>9. Intellectual Property</h2>
      <p>All website content, including text, images, and logos, is our property or licensed for use.</p>
      <ul>
        <li>Unauthorized reproduction, distribution, or modification is prohibited.</li>
      </ul>

      <h2>10. Limitation of Liability</h2>
      <p>We are not liable for any indirect or consequential losses arising from the use of our services.</p>
      <ul>
        <li>Our liability is limited to the value of the order placed by the customer.</li>
        <li>Consumer rights under the Consumer Guarantees Act 1993 and Fair Trading Act 1986 are not excluded by these terms.</li>
      </ul>

      <h2>11. Privacy Policy</h2>
      <p>We collect and process personal data in accordance with New Zealand's Privacy Act 2020.</p>
      <p>By using our service, you consent to the collection and use of your information as described in our Privacy Policy.</p>

      <h2>12. Changes to Terms</h2>
      <p>We reserve the right to update these Terms and Conditions at any time.</p>
      <p>Continued use of our service after modifications constitutes acceptance of the changes.</p>

      <h2>13. Governing Law</h2>
      <p>These terms are governed by the laws of New Zealand.</p>
      <p>Any disputes shall be resolved in the courts of New Zealand.</p>

      <h2>14. Contact Information</h2>
      <p>For any inquiries or support, please contact us at <a href="mailto:sairamtradersnz@gmail.com">sairamtradersnz@gmail.com</a> / 027 4423866</p>
    </div>
  );
};

export default TermsAndConditions;
